import { useHoverStore } from "@/components/Inputs/RangePicker/stores/useHoverStore.ts";
import { memo } from "react";
import { CalendarDay } from "react-day-picker";

export const DayButton = memo((props: { day: CalendarDay }) => {
  const setHoveredDate = useHoverStore((state) => state.setHoveredDate);

  return <button onMouseEnter={() => setHoveredDate(props.day.date)} {...props} />;
});

DayButton.displayName = "DayButton";
